import baseUrl, { image } from '../utils/data/baseUrl';

export const controls = ({ level, step, score = 0, settings, targetScore, maxSteps }) => {
  return [
    {
      title: 'gameMatch3.level',
      count: level + 1,
    },
    {
      title: 'gameMatch3.steps',
      count: `${step}/${maxSteps || settings?.maxSteps}`,
    },
    {
      title: 'gameMatch3.score',
      count: `${score}/${targetScore || settings?.targetScore}`,
    },
  ];
};

export const bg = [
  {
    image: image('three/bag-1.png'),
  },
  {
    image: image('three/bag-2.png'),
  },
  {
    image: image('three/bag-3.png'),
  },
];

export const rules = {
  list: [
    {
      image: image('three/rules/1.png'),
      text: 'gameMatch3.rules.1',
    },
    {
      image: image('three/rules/2.png'),
      text: 'gameMatch3.rules.2',
    },
    {
      image: image('three/rules/3.png'),
      text: 'gameMatch3.rules.3',
    },
  ],
  button: {
    className: 'three-rules__button',
    text: 'other.understand',
    text2: 'other.next',
    text3: 'other.start',
  },
};

export const infoFirstStep = {
  image: image('three/info/img1.png'),
  title: 'Пора в&nbsp;отпуск вместе с&nbsp;S7&nbsp;Priority!',
  text: 'Распределите вещи в&nbsp;ручной клади так, чтобы больше поместилось',
  button: {
    className: 'three-info__button',
    text: 'Дальше',
  },
};

export const info = [
  {
    type: '1',
    image: image('three/info/img2.png'),
    title: 'Супер, ручная кладь собрана',
    text: 'С&nbsp;S7&nbsp;Priority доступно больше: со&nbsp;статусом Classic Expert берите с&nbsp;собой бесплатный дополнительный багаж до&nbsp;23&nbsp;кг',
    button: {
      className: 'three-info__button',
      text: 'Продолжить',
    },
  },
  {
    image: image('three/info/img3.png'),
    title: 'Отлично! \nЧемодан собран,',
    text: 'А&nbsp;со&nbsp;статусом Platinum берите с&nbsp;собой бесплатный дополнительный багаж до&nbsp;32&nbsp;кг. Круто!',
    button: {
      className: 'three-info__button',
      text: 'Продолжить',
    },
  },
  {
    type: '4',
    image: image('three/info/img4.png'),
    title: 'Класс!',
    text: 'Вы&nbsp;уложились в&nbsp;1,5 минуты и&nbsp;собрали багаж. Но&nbsp;чтобы получить счастливый билет, нужно собрать три билетика на&nbsp;этом уровне',
    button: {
      className: 'three-info__button',
      text: 'Вернуться',
    },
  },
  {
    type: '5',
    image: image('three/info/img5.png'),
    title: 'Упс, вы не успели',
    text: 'Попробуйте еще раз&nbsp;&mdash; обязательно получится',
    button: {
      className: 'three-info__button',
      text: 'Сыграть ещё',
    },
  },
  {
    type: '6',
    image: image('three/info/img6.png'),
    title: 'Поздравляем!',
    text: 'Вы&nbsp;уложились в&nbsp;полторы минут и&nbsp;собрали багаж так, что все поместилось. А&nbsp;еще нашли счастливый билет!',
    button: {
      className: 'three-info__button',
      text: 'Отлично',
    },
  },
];
